module.exports = __webpack_public_path__ + "static/media/Vector-18.399aec76.svg";